import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import axiosInstance from "../../hooks/axiosInstance"
import { toast } from "react-toastify"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Pagination } from "@mui/material"
import Loader from "../../components/utilities/Loader/Loader"

export default function MyApplicationsPage() {
    const [loading, setLoading] = useState(false)
    const [applications, setApplications] = useState([])
    const [currentApplication, setCurrentApplication] = useState(null)
    const [joinOpen, setJoinOpen] = useState(false)
    const [cancelOpen, setCancelOpen] = useState(false)
    const [isJoinLoading, setIsJoinLoading] = useState(false)

    const [filter, setFilter] = useState({
        search: '', status: ''
    })


    //  state for pagination
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(1);
    
    //  pagination function
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleFilterChange = (e) => {
        const {name, value} = e.target

    setFilter(prevFilter => (
            {...prevFilter, [name]: value}
        ))
    }

    const handleStatusOpen = async(application, status) => {
        await setCurrentApplication({...application, treatStatus: status})
        await setJoinOpen(true)
    }

    const handleCancelOpen = async(application) => {
        await setCurrentApplication(application)
        await setCancelOpen(true)
    }

    const fetchUserApplications = () => {
        setLoading(true)
        axiosInstance.post(`/user/associations/applications?page=${page}`, filter)
              .then(response => {
                setApplications(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }


    const rejoinAssociation = () => {
        setJoinOpen(false)
        setIsJoinLoading(true)
        axiosInstance.post(`/user/associations/rejoin/${currentApplication.id}`, currentApplication)
              .then(res => {
                toast.success(res.data.message)
                fetchUserApplications()
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setIsJoinLoading(false))
    }

    const cancelRequest = () => {
        setCancelOpen(false)
        setIsJoinLoading(true)
        axiosInstance.post(`/user/associations/applications/cancel/${currentApplication.id}`, currentApplication)
              .then(res => {
                toast.success(res.data.message)
                fetchUserApplications()
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setIsJoinLoading(false))
    }

    useEffect(() => {
        fetchUserApplications()
    }, [page])

    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">My Applications</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">My Applications</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            <div className="row" id="contactList">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header d-flex align-items-center border-0">
                            <h5 className="card-title mb-0 flex-grow-1">My Applications</h5>
                            {/* <div className="flex-shrink-0">
                                <div className="flax-shrink-0 hstack gap-2">
                                    <button className="btn btn-primary">Today's Orders</button>
                                    <button className="btn btn-soft-info">Past Orders</button>
                                </div>
                            </div> */}
                        </div>
                        <div className="card-body border border-dashed border-end-0 border-start-0">
                            <div className="row g-2">
                                <div className="col-xl-4 col-md-6">
                                    <div className="search-box">
                                        <input 
                                            type="text" 
                                            className="form-control search" 
                                            placeholder="Search applications..."
                                            name="search"
                                            value={filter.search}
                                            onChange={handleFilterChange}
                                            />
                                        <i className="ri-search-line search-icon"></i>
                                    </div>
                                </div>
                                {/* <!--end col--> */}
                                {/* <div className="col-xl-3 col-md-6">
                                    <div className="input-group">
                                        <span className="input-group-text" id="basic-addon1"><i className="ri-calendar-2-line"></i></span>
                                        <input type="text" className="form-control" data-date-format="d M, Y" data-range-date="true" placeholder="Select date" id="range-datepicker" aria-describedby="basic-addon1" />
                                    </div>
                                </div> */}
                                {/* <!--end col--> */}
                                <div className="col-xl-2 col-md-4">
                                    <select 
                                        className="form-control" 
                                        name="status" 
                                        value={filter.status}
                                        onChange={handleFilterChange}
                                        >
                                        <option value="all">Select Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="approved">Approved</option>
                                        <option value="declined">Declined</option>
                                        {/* <option value="Pending">Pending</option> */}
                                    </select>
                                </div>
                                {/* <!--end col--> */}
                                <div className="col-xl-1 col-md-4" onClick={fetchUserApplications}>
                                    <button className="btn btn-success w-100">Filter</button>
                                </div>
                            </div>
                            {/* <!--end row--> */}
                        </div>
                        <div className="card-body">
                            {applications.length > 0 && (
                                <>
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle table-nowrap" id="customerTable">
                                            <thead className="table-light text-muted">
                                                <tr>
                                                    <th className="sort" data-sort="currency_name" scope="col">Association Info</th>
                                                    <th className="sort" data-sort="type" scope="col">Membership Type</th>
                                                    <th className="sort" data-sort="quantity_value" scope="col">Membership Fee</th>
                                                    <th className="sort" data-sort="time" scope="col">Request Date</th>
                                                    <th className="sort" data-sort="status" scope="col">Status</th>
                                                    {/* <th className="sort" data-sort="status" scope="col">Membership Status</th> */}
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            {/* <!--end thead--> */}
                                            <tbody className="list form-check-all">
                                                {applications.map(application => (
                                                    <tr key={application.id}>
                                                        <td className="id" style={{display:"none"}}><a href="javascript:void(0);" className="fw-medium link-primary">#VZ001</a></td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-shrink-0">
                                                                    <img src="/assets/images/svg/crypto-icons/btc.svg" alt="" className="avatar-xs" />
                                                                </div>
                                                                <a href="javascript:void(0);" className="flex-grow-1 ms-2 currency_name">
                                                                    <span className="m-0">{application.association.name}</span>
                                                                    <p className="m-0 text-muted" style={{lineHeight: 1.5}}>{application.association?.email}</p>
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td className={`type ${application.association?.membership_mode == 'free' ? 'text-success' : 'text-danger'} text-capitalize`}>
                                                            {application.association?.membership_mode}
                                                            </td>
                                                        <td className="id">{application.association.membership_fee ? `₦${Number(application.association?.membership_fee).toLocaleString()}` : '-'}</td>
                                                        <td className="order_date time" data-timestamp="1641945600">
                                                            {application.created_at}
                                                        </td>
                                                        <td className="status">
                                                            <span 
                                                                className={`badge ${application.status == 'approved' ? 'bg-success-subtle text-success' :
                                                                    application.status == 'pending' ? 'bg-warning-subtle text-warning' : 'bg-danger-subtle text-danger'
                                                                } text-uppercase`}
                                                                >
                                                                {application.status}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div className="dropdown">
                                                                <button className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className="ri-more-fill"></i>
                                                                </button>
                                                                <ul className="dropdown-menu">
                                                                    {application.status == 'pending' && (
                                                                        <li onClick={() => handleCancelOpen(application)}>
                                                                            <a className="dropdown-item cursor-pointer">
                                                                                <i className="ri-delete-bin-5-fill text-muted me-2 align-bottom"></i>Cancel Request
                                                                            </a>
                                                                        </li>
                                                                    )}
                                                                    {application.status == 'declined' && (
                                                                        <li onClick={() => handleStatusOpen(application, 'pending')}>
                                                                            <a className="dropdown-item cursor-pointer">
                                                                                <i className="ri-stack-line text-muted me-2 align-bottom"></i>Re-join
                                                                            </a>
                                                                        </li>
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {/* <!--end tr--> */}
                                            </tbody>
                                        </table>
                                        {/* <!--end table--> */}
                                    </div>
                                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                                        {/* <div className="col-sm-6">
                                            <div>
                                                <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">1</span> to <span className="fw-semibold">10</span> of <span className="fw-semibold text-decoration-underline">12</span> entries</p>
                                            </div>
                                        </div> */}
                                        {/* <!-- end col --> */}
                                        <div className="col-sm-12 d-flex justify-content-end mt-4">
                                            <Pagination 
                                                onChange={handlePageChange}  
                                                count={pageCount} 
                                                color="primary" 
                                                shape="rounded"
                                                size="small"
                                                page={page}
                                            />
                                        </div>
                                        {/* <!-- end col --> */}
                                    </div>
                                </>
                            )}
                            {applications.length == 0 && (
                                <div className="noresult">
                                    <div className="text-center">
                                        <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                        <h5 className="mt-2">Sorry! No Result Found</h5>
                                        {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <!--end card--> */}
                </div>
                {/* <!--end col--> */}
            </div>
            {/* <!--end row--> */}

            {/* Rejoin associtaion Dialog */}
            {currentApplication && (
                <>
                    <Dialog
                        open={joinOpen}
                        onClose={() => setJoinOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                    <DialogTitle id="alert-dialog-title">
                        Re-Join <b className="text-primary">{currentApplication.association?.name}</b> {" "}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        Are you sure you want to perform this operation?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button className="text-danger" onClick={() => setJoinOpen(false)}>
                        Cancel
                        </Button>
                        <Button onClick={rejoinAssociation} autoFocus>
                        Continue
                        </Button>
                    </DialogActions>
                    {isJoinLoading && <Loader />}
                    </Dialog>

                    {loading && <Loader />}
                </>
            )}

            {/* cancel application Dialog */}
            {currentApplication && (
                <>
                    <Dialog
                        open={cancelOpen}
                        onClose={() => setCancelOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                    <DialogTitle id="alert-dialog-title">
                        Cancel request to join <b className="text-primary">{currentApplication.association?.name}</b> {" "}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        Are you sure you want to perform this operation?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button className="text-danger" onClick={() => setCancelOpen(false)}>
                        Cancel
                        </Button>
                        <Button onClick={cancelRequest} autoFocus>
                        Continue
                        </Button>
                    </DialogActions>
                    {isJoinLoading && <Loader />}
                    </Dialog>

                    {loading && <Loader />}
                </>
            )}

            {loading && <Loader />}
        </>
    )
}